import { Trans } from '@lingui/macro'
import { Button, MenuItem } from '@mui/material'
import FolderSharedIcon from '@mui/icons-material/FolderShared'

import { useIsLargeScreen } from '@/hooks/useIsLargeScreen'

type OpenDMPProps = {
  patientId: string
  onClose?: () => void
}

export function OpenDMP({ patientId, onClose }: OpenDMPProps) {
  const isLargeScreen = useIsLargeScreen()

  const handleClick = () => {
    window.open(`/efficience-web?patientId=${patientId}`, '_blank')
    onClose?.()
  }

  if (isLargeScreen) {
    return (
      <Button startIcon={<FolderSharedIcon />} variant="contained" onClick={handleClick}>
        DMP
      </Button>
    )
  }

  return (
    <MenuItem onClick={handleClick} disableRipple>
      <FolderSharedIcon />
      DMP
    </MenuItem>
  )
}
